var _circle, _circle2, _circle3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignCircles(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 342,
    viewBox: "0 0 148 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4193,
    cy: 255.087,
    r: 36.6899,
    transform: "rotate(15 62.4193 255.087)",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.89744,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 27.5228 266.558)",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1.89744,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 62.39 218.541)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-95.4071 294.265C-24.0729 313.379 49.2499 271.046 68.3639 199.712C87.4778 128.378 45.1449 55.0551 -26.1894 35.9412C-97.5236 16.8272 -170.846 59.1601 -189.96 130.494C-209.074 201.829 -166.741 275.151 -95.4071 294.265ZM-95.666 295.231C-23.7982 314.488 50.0729 271.839 69.3298 199.971C88.5867 128.103 45.9372 54.2322 -25.9305 34.9753C-97.7983 15.7183 -171.669 58.3679 -190.926 130.236C-210.183 202.103 -167.534 275.974 -95.666 295.231Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignCircles);
export default __webpack_public_path__ + "static/media/SignCircles.7b8beec1b170da3d310481ee7c54a9af.svg";
export { ForwardRef as ReactComponent };